export const config = {
  ENV: "production",
  //API_URL: 'https://fdmf.ccbr.umn.edu',
  AUTH_URL: 'https://fdmf.ccbr.umn.edu',
  API_URL_LIST: [
    {id: 0, url: "https://fdmf.ccbr.umn.edu", name: "BloodSafe (Production)"},
    {id: 1, url: "https://fdmf.ccbr.umn.edu", name: "BloodSafe (Test)"},
    {id: 2, url: "https://fdmf.ccbr.umn.edu", name: "Yellow Fever (Production)"},
    {id: 3, url: "https://fdmf.ccbr.umn.edu", name: "Yellow Fever (Test)"},
    {id: 4, url: "https://fdmf.ccbr.umn.edu", name: "IC-SARI (Test)"}

  ]
};
